import { Component } from 'react';

import { configValue } from '#/config/appConfigUtils';
import { I18n } from '#/i18n/components/I18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { recaptcha } from '#/utils/recaptcha';

import { StyledRecaptchaInput } from './RecaptchaInput.styled';

type RecaptchaInputProps = {
  onChange: (response?: string) => void;
  siteKey?: string | null;
};

export class RecaptchaInput extends Component<RecaptchaInputProps> {
  setupRecaptcha = (el: Element | null | undefined, locale: I18nLocale) => {
    if (!el) return;
    void recaptcha({ locale }).then((r) => {
      const { siteKey, onChange } = this.props;
      r.render(el, {
        sitekey: siteKey ?? configValue('google', 'recaptcha', 'siteKey'),
        callback: (response: string) => {
          onChange(response);
        },
        'expired-callback': () => {
          // Remove old value because it's no longer valid
          onChange();
        },
      });
    });
  };

  render() {
    return (
      <I18n
        render={({ locale }) => (
          <StyledRecaptchaInput ref={(el) => this.setupRecaptcha(el, locale)} />
        )}
      />
    );
  }
}
